module.exports = __webpack_public_path__ + "img/secure-logos.1b0328a2.png";